import script from "./scroll-to-top.vue?vue&type=script&setup=true&lang=js"
export * from "./scroll-to-top.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__